import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function CalendarMoveIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M13 12V10L17 13L13 16V14H7V12H13Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 19V3H17V2H15V3H9V2H7V3H2V19C2 20.6543 3.3457 22 5 22H19C20.6543 22 22 20.6543 22 19ZM17 5H20V19C20 19.5513 19.5518 20 19 20H5C4.44824 20 4 19.5513 4 19V5H7V7H9V5H15V7H17V5Z",
    fill: "currentColor"
  }));
}